import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto text-center">
        <p className="mb-2">
          &copy; {new Date().getFullYear()} Justin Wang Portfolio. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
